import styled from 'styled-components';
import { media } from 'designsystem/index';

const AbsoluteWrapper = styled.div`
  position: absolute;
  width: 100%;
  z-index: 0;
  overflow: hidden;
  height: 365px;

  ${media.desktop`
    height: 515px;
  `}
`;

export default AbsoluteWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/AbsoluteWrapper.jsx